import { DeliveryAreaPolygonMap } from "../shared/models";
import { Coordinates } from "../shared/models/geocoding.model";

export class DeliveryAreaService {

    public static FindDeliveryZone(coordinates: Coordinates, deliveryZones: DeliveryAreaPolygonMap[]) {
        let possibleDeliveryZones = deliveryZones.filter(zone => DeliveryAreaService.IsInArea(coordinates, zone));
        return this.FindCheapestDeliveryZone(possibleDeliveryZones);
    }

    private static FindCheapestDeliveryZone(possibleDeliveryZones: DeliveryAreaPolygonMap[]): DeliveryAreaPolygonMap {
        let cheapest = null;
        let lowestFee = Number.MAX_VALUE;
        possibleDeliveryZones.forEach(zone => {
            const defaultFee = zone.DeliveryFees.reduce((min, fee) => {
                return fee.ShoppingCartValue < min ? fee.ShoppingCartValue : min;
            }, zone.DeliveryFees[0].ShoppingCartValue);

            if (defaultFee < lowestFee) {
                lowestFee = defaultFee;
                cheapest = zone;
            }
        });

        return cheapest;
    }

    /// <summary>
    /// Validates if the given coordinate is in the area defined in the delivery area
    /// Returns true if the coordinate is in the area, false otherwise
    /// </summary>
    public static IsInArea(x: Coordinates, deliveryArea: DeliveryAreaPolygonMap): boolean {
        let polygon = deliveryArea.Coordinates;

        let pointIsMissing = x === null || x === undefined;
        let polygonIsFaulty = polygon === null || polygon === undefined || polygon.length < 3;

        if (pointIsMissing || polygonIsFaulty) {
            return false;
        }

        // Ray casting algorithm (https://en.wikipedia.org/wiki/Point_in_polygon)
        let elements = polygon.length;
        let isInside = false;

        // Given latitude and longitude you can think of it as a point on a 2D plane with X and Y coordinates as longitude and latitude.
        // The loop iterates over each "edge" of the polygon, defined by the vertices (A,B) from polygon[i] and polygon[j].
        for (let i = 0, j = elements - 1; i < elements; j = i++) {
            let a = polygon[i];
            let b = polygon[j];

            // This just means that the point is within the latitude range of the edge.
            let latitudeIsBetweenPoints = a.Latitude > x.Latitude !== b.Latitude > x.Latitude;

            if (latitudeIsBetweenPoints) {
                // The point is on the left side of the edge if the longitude of the point is less than the longitude of the intersection of the edge with the latitude of the point.
                // https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection
                // Now check the longitude aka the X coordinate. If the point is on the left side of the edge, then the point is inside the polygon.
                let gradient = b.Longitude - a.Longitude; // The gradient of the edge.
                let left = x.Latitude - a.Latitude;
                let difference = b.Latitude - a.Latitude; // The difference between the latitude of the edge and the latitude of the other edge.
                let intersection = ((gradient * left) / difference) + a.Longitude; // The longitude of the intersection of the edge with the latitude of the point.
                let isOnLeft = x.Longitude < intersection; // The point is on the left side of the edge.
                isInside = isOnLeft ? !isInside : isInside;
            }
        }

        return isInside;
    }
}